import AxiosAdminAPI from "../../../../util/AxiosAdminAPI";
import EnterpriseComponent from "../../EnterpriseComponent";
import {V1PrivilegeIDOCToArray} from "../../../../util/Payload";
import MemoryContext from "../../../../util/MemoryContext";
import {v4 as uuidv4} from "uuid";

class PrivilegeConstraintEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, _) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        let idocResponse = this.getIDOCResponse() ?? "v1.PrivilegeConstraint-001";

        AxiosAdminAPI({
            method: "GET",
            url: "t6/v1/privilege_constraints",
            json: true,
            params: {
                "Limit": pageSize,
                "Offset": (page - 1) * pageSize,
                "Sort": this.getFormattedSortSpecification(),
                "Name": this.getAttributeValue("Name"),
                "ParentUSID": this.getAttributeValue("ParentUSID"),
            },
            headers: {
                "idoc-response": idocResponse,
            },
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1PrivilegeIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };

    enterpriseComponentPutIDOC = () => {
        let payload = {};

        let adminPrivilege = {
            "USID": MemoryContext.components["Privilege-PrivilegeUSID"]
        }

        let PrivilegeConstraint = {}
        PrivilegeConstraint["USID"] = uuidv4();
        PrivilegeConstraint["PrivilegeUSID"] = MemoryContext.components["Privilege-PrivilegeUSID"];
        PrivilegeConstraint["ParentUSID"] = MemoryContext.components["Privilege-ParentUSID"];
        PrivilegeConstraint["Name"] = this.getAttributeValue("Name");
        PrivilegeConstraint["Type"] = MemoryContext.components["Privilege-Type"];
        PrivilegeConstraint["AccountUserUSID"] = this.getAttributeValue("AccountUserUSID");

        adminPrivilege["PrivilegeConstraint"] = PrivilegeConstraint

        payload.PlatformMessage = {};
        payload.PlatformMessage["-idoc"] = "v1.Privilege-001";
        payload.PlatformMessage["Privilege"] = adminPrivilege;

        return payload;
    };

    performInsert = () => {
        let payload = this.enterpriseComponentPutIDOC();

        let options = {
            method: "PUT",
            url: "t6/v1/privileges",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.Privilege-001",
                "idoc-response": this.getIDOCResponse(),
            },
        };
        this.notifyInsertStartListeners();
        AxiosAdminAPI(options)
            .then(response => {
                this.insertEnterpriseComponentSuccess(V1PrivilegeIDOCToArray(response.data));
            })
            .catch(error => {
                this.insertEnterpriseComponentFailed(error);
            });
    };

    performDelete() {
        let payload = {
            "PlatformMessage": {
                "-idoc": "v1.PrivilegeConstraint-001",
                "PrivilegeConstraint": {
                    "USID": MemoryContext.components["Privilege-PrivilegeConstraintUSID"]
                }
            }
        }

        let options = {
            method: "DELETE",
            url: "t6/v1/privilege_constraints",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.PrivilegeConstraint-001"
            },
        };
        this.notifyDeleteStartListeners();
        AxiosAdminAPI(options)
            .then(() => {
                this.deleteEnterpriseComponentSuccess();
            })
            .catch(error => {
                this.deleteEnterpriseComponentFailed(error);
            });
    };
}



export default PrivilegeConstraintEnterpriseComponent;